import { z } from 'zod'

export const additionalInfoBaseSchema = z.object({
  gender: z.enum(['female', 'male', 'non_binary', 'unspecified'], {
    errorMap: () => ({ message: 'Please select your gender' }),
  }),
  birthdate: z.coerce.date({
    errorMap: () => ({
      message: 'Please select your date of birth',
    }),
  }),
  nationality: z.string().min(1, { message: 'Please select your nationality' }),
  careerLevel: z.string().min(1, { message: 'Please input your career level' }),
  expertiseAreas: z
    .array(z.string())
    .min(1, 'Please select at least 1 expertise'),
  techStack: z.array(z.string()).min(1, 'Please select at least 1 technology'),
})
export type AdditionalInfoType = z.infer<typeof additionalInfoBaseSchema>
